module.exports = __webpack_public_path__ + "static/media/pampa.e5d9c1ab.mp3";